export default __webpack_public_path__ + "static/media/abono.25677e78.svg";